import { combineReducers } from 'redux';
import documents from './case-documents.reducer';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

const reducers: CMx.HistoricalReducer = (history: History) => {
  return combineReducers({
    documents,
    router: connectRouter(history)
  });
};

export default reducers;
